import React, { Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Boxes from './Boxes/Boxes'
import { uiConstants } from '../../../constants'
import css from './Home.module.scss'
import Box from '../../UI/Box/Box'
import Stupro from '../../../assets/stupro.jpg'
import { timeHelper } from '../../../helpers'

const Home = ({ courses }) => {
  const randomIndex = useMemo(
    () => Math.floor(Math.random() * uiConstants.sliders.length),
    []
  )
  const s = uiConstants.sliders[randomIndex]

  const todaysCourses = (courses.list || []).filter((x) =>
    x.lessons.find(
      (y) =>
        y.day === new Date().getDay() &&
        timeHelper.dateInputToTime(y.start) <= timeHelper.now() &&
        timeHelper.dateInputToTime(y.end) >= timeHelper.now()
    )
  )

  return (
    <Fragment>
      <div className={css.Splash}>
        <img src={s.image} alt={s.middle} />
        <div className={css.Text}>
          <span className={css.Title}>{s.title}</span>
          {s.description}
          <Link to={s.to} className={css.Link}>
            {s.label}
          </Link>
        </div>
      </div>

      <Boxes />
      <div className={css.Today}>
        <div>
          <Box
            title='Lezioni di oggi'
            description={
              todaysCourses.length > 0
                ? todaysCourses
                    .map((x) => `${x.name} (${x.country_code})`)
                    .join(', ')
                : 'Oggi non ci sono lezioni, scopri dove siamo!'
            }
            to='/dove-siamo'
            image={Stupro}
          />
        </div>
      </div>
    </Fragment>
  )
}
function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(Home)
